import { useSelector } from 'react-redux'
import store from 'state/store'
export const METABASE_REPORTS = [
  {
    id: 'Net-Weight-Received-by-Customer',
    name: 'Net Weight Received by Customer',
    description: 'All Received Material, Grouped by Customer',
    category: 'Receiving',
    reportId: 967,
    reportType: 'METABASE',
  },
  {
    id: 'Inventory-Report-Weights',
    name: 'Inventory Report - Weights',
    description: 'Inventory Weight Reports by Commodity and Material',
    category: 'Inventory',
    reportId: 641,
    treatment: 'GREEN-7161-inventory-overhaul',
    reportType: 'METABASE',
  },
  {
    id: 'Inventory-Report-Costs',
    name: 'Inventory Report - Costs',
    description: 'Inventory Costing Report by Commodity and Material',
    category: 'Inventory',
    reportId: 644,
    treatment: 'GREEN-7161-inventory-overhaul',
    reportType: 'METABASE',
  },
  {
    id: 'Net-Weight-Shipped-by-Customer',
    name: 'Net Weight Shipped by Customer',
    description: 'All Shipped Material, Grouped by Customer',
    category: 'Shipping',
    reportId: 1130,
    reportType: 'METABASE',
  },
  {
    id: 'Purchases-By-Customer',
    name: 'Purchases By Customer',
    description: 'All Purchases, Grouped by Customer',
    category: 'Purchases',
    reportId: 1098,
    reportType: 'METABASE',
  },
  {
    id: 'Finished-Good-Report',
    name: 'Finished Good Report',
    description: 'All Finished Goods (Available + Unavailable)',
    category: 'Inventory',
    reportId: 648,
    reportType: 'METABASE',
  },
  {
    id: 'Summary-Purchase-Order-Report',
    name: 'Summary Purchase Order Report',
    description: 'All Purchase Orders / Fulfillment Levels, Grouped by Customer / Commodity / Material',
    category: 'Contracts',
    reportId: 645,
    reportType: 'METABASE',
  },
  {
    id: 'Summary-Sales-Order-Reports',
    name: 'Summary Sales Order Reports',
    description: 'All Sales Orders / Fulfillment Levels, Grouped by Customer / Commodity / Material',
    category: 'Contracts',
    reportId: 649,
    reportType: 'METABASE',
  },
  {
    id: 'Price-Snapshot',
    name: 'Price Snapshot View',
    description: 'List of all materials/prices and date last updated',
    category: 'Commodities',
    reportId: 900,
    reportType: 'METABASE',
  },
  {
    id: 'Operation-Inventory-Position',
    name: 'Inventory Position - Operational',
    description: 'Operation Inventory Position / Exposure Analysis',
    category: 'Inventory',
    reportId: 654,
    reportType: 'METABASE',
  },
  {
    id: 'Operation-Inventory-Financial',
    name: 'Inventory Position - Financial',
    description: 'Financial Inventory Position / Exposure Analysis',
    category: 'Inventory',
    reportId: 653,
    reportType: 'METABASE',
  },
  {
    id: 'Inventory-Reconciliation',
    name: 'Inventory Reconciliation',
    description: 'Time-Based Inventory Reconciliation Analysis',
    category: 'Inventory',
    reportId: 1064,
    reportType: 'METABASE',
  },
  {
    id: 'British-Columbia-Regulatory-Report',
    name: 'British Columbia Regulatory Report',
    description: 'British Columbia Compliance Report',
    category: 'Compliance',
    reportId: 656,
    treatment: 'GREEN-6477_Embed_Metabase_Report_136',
    reportType: 'METABASE',
  },
  {
    id: 'Alberta-Regulatory-Reporting',
    name: 'Alberta Regulatory Reporting',
    description: 'Alberta Compliance Report',
    category: 'Compliance',
    reportId: 655,
    reportType: 'METABASE',
  },
  {
    id: 'Cash-Drawer-Report',
    name: 'Cash Drawer Report',
    description: 'Cash Drawer Report',
    category: 'Settings',
    reportId: 657,
    reportType: 'METABASE',
  },
  {
    id: 'Texas-DPS-Upload',
    name: 'Texas DPS Upload',
    description: 'Paid IBTs for Texas DPS Upload',
    category: 'Purchases',
  },
  {
    id: 'VIN-Report',
    name: 'VIN Report',
    description: 'List of all cars that were bought as scrap vehicles by a yard',
    category: 'Purchases',
    reportId: 658,
    reportType: 'METABASE',
  },
  {
    id: 'Master-Customers-Report',
    name: 'Master Customers Report',
    description: 'Master Customers Report, including general information, locations and contacts',
    category: 'Customers',
    reportId: 660,
    reportType: 'METABASE',
  },
  {
    id: 'Summary-Invoicing-Report',
    name: 'Summary Invoicing Report',
    description: 'Report of all invoices created in GreenSpark',
    category: 'Sales',
    reportId: 1196,
    reportType: 'METABASE',
  },
  {
    id: 'Inbound-Ticket-Audit-Report',
    name: 'Inbound Ticket Audit Report',
    description: 'Internal Audit Report tracking for Inbound Tickets',
    category: 'Purchases',
    reportId: 662,
    reportType: 'METABASE',
  },
  {
    id: 'Sales-Margin-Report',
    name: 'Sales / Margin Report',
    description: 'Sales - Margin Analysis by Material and Commodity',
    category: 'Sales',
    reportId: 663,
    reportType: 'METABASE',
  },
  {
    id: 'Positive-Pay-Report',
    name: 'Positive Pay Report',
    description: 'Check Purchase Export for Positive Pay',
    category: 'Purchases',
    reportId: 664,
    treatment: 'GREEN-7825_Metabase_Report_341_Positive_Pay',
    reportType: 'METABASE',
  },
  {
    id: 'Tax-Report',
    name: 'Tax Report',
    description: 'A history of taxes paid on all inbound transactions',
    category: 'Purchases',
    reportId: 659,
    reportType: 'METABASE',
  },
  {
    id: 'Purchases-By-Material',
    name: 'Purchases By Material',
    description: 'All Purchases, Grouped by Material',
    category: 'Purchases',
    reportId: 665,
    reportType: 'METABASE',
  },
  {
    id: 'Payment-Holds',
    name: 'Payment Holds',
    description: 'All Tickets and Materials with Payment Holds',
    category: 'Purchases',
    reportId: 1164,
    reportType: 'METABASE',
  },
  {
    id: 'Dispatch-Ticket-Report',
    name: 'Dispatch Ticket Report',
    description: 'Summary Report of Dispatch Tickets',
    category: 'Dispatch',
    reportId: 801,
    treatment: 'app-route-load-board',
    reportType: 'METABASE',
  },
  {
    id: 'Containers-Report',
    name: 'Containers Report',
    description: 'Summary Report of Container Status and Utilization',
    category: 'Dispatch',
    reportId: 802,
    treatment: 'app-route-load-board',
    reportType: 'METABASE',
  },
  {
    id: 'Inbound-Freight-Cost-Report',
    name: 'Inbound Freight Cost Report',
    description: 'Inbound Freight Cost Analysis by Carrier / Customer',
    category: 'Freight',
    reportId: 'BKxgDkP1LR',
    reportType: 'EXPLO',
  },
  {
    id: 'Outbound-Freight-Cost-Report',
    name: 'Outbound Freight Cost Report',
    description: 'Outbound Freight Cost Analysis by Carrier / Customer',
    category: 'Freight',
    reportId: '08YWnqnAW4',
    reportType: 'EXPLO',
  },
  {
    id: 'Payables-Report-Bills',
    name: 'Payables Report',
    description: 'Payables Report',
    category: 'Purchases',
    reportId: 'V4ArzVgAmD',
    orgLevelReportId: '5L1BOPKAqe',
    reportType: 'EXPLO',
  },
  {
    id: 'Receivables-Report',
    name: 'Receivables Report',
    description: 'All overdue and forecasted receivables',
    category: 'Sales',
    reportId: '5rxlq631J9',
    orgLevelReportId: 'BKxgqvBALR',
    reportType: 'EXPLO',
  },
]

export const EXPLO_REPORTS = [
  {
    id: 'Net-Weight-Received-by-Customer',
    name: 'Net Weight Received by Customer',
    description: 'All Received Material, Grouped by Customer',
    category: 'Receiving',
    reportId: 'PD1jyKJxvm',
    orgLevelReportId: '38xvOn912j',
    reportType: 'EXPLO',
  },
  {
    id: 'Daily-Snapshot-Report',
    name: 'Daily Snapshot',
    description: 'Daily snapshot of activity on GreenSpark',
    category: 'General',
    reportId: 'PD1jZom1vm',
    orgLevelReportId: null,
    reportType: 'EXPLO',
  },
  {
    id: 'Inventory-Report',
    name: 'Inventory Report - Weights and Costs',
    description: 'Current Inventory Weight and Cost Report by Commodity and Material',
    category: 'Inventory',
    reportId: '08YWyoN1W4',
    orgLevelReportId: '5L1B8n6Yqe',
    reportType: 'EXPLO',
    treatment: 'GREEN-7161-inventory-overhaul',
  },
  {
    id: 'Net-Weight-Shipped-by-Customer',
    name: 'Net Weight Shipped by Customer',
    description: 'All Shipped Material, Grouped by Customer',
    category: 'Shipping',
    reportId: '5L1B8vLYqe',
    orgLevelReportId: '2k1LPVd1yJ',
    reportType: 'EXPLO',
  },
  {
    id: 'Purchases-By-Customer',
    name: 'Purchases By Customer',
    description: 'All Purchases, Grouped by Customer',
    category: 'Purchases',
    reportId: '2WYnbGkYZX',
    orgLevelReportId: 'aBAMpnN1kv',
    reportType: 'EXPLO',
  },
  {
    id: 'Finished-Good-Report',
    name: 'Finished Good Report',
    description: 'All Finished Goods (Available + Unavailable)',
    category: 'Inventory',
    reportId: 'EbY2bqaYyD',
    orgLevelReportId: 'jDxeV7e1LG',
    reportType: 'EXPLO',
  },
  {
    id: 'Finished-Good-Audit-Report',
    name: 'Finished Good Audit Report',
    description: 'All Finished Goods (Available + Unavailable) with Audit Details',
    category: 'Inventory',
    reportId: 'P8xK5LbAoZ',
    orgLevelReportId: 'p9177lV1a3',
    reportType: 'EXPLO',
  },
  {
    id: 'Summary-Purchase-Order-Report',
    name: 'Summary Purchase Order Report',
    description: 'All Purchase Orders / Fulfillment Levels, Grouped by Customer / Commodity / Material',
    category: 'Contracts',
    reportId: 'b81JkqnAag',
    orgLevelReportId: 'dK1o09OAl0',
    reportType: 'EXPLO',
  },
  {
    id: 'Summary-Sales-Order-Reports',
    name: 'Summary Sales Order Reports',
    description: 'All Sales Orders / Fulfillment Levels, Grouped by Customer / Commodity / Material',
    category: 'Contracts',
    reportId: 'jv1ORdoxzp',
    orgLevelReportId: 'PD1jOjjAvm',
    reportType: 'EXPLO',
  },
  {
    id: 'Regrade-Report',
    name: 'Regrade Report',
    description: 'Regrade From and To Analysis',
    category: 'Inventory',
    reportId: 'PD1j8ByYvm',
    orgLevelReportId: 'EbY22wBYyD',
    reportType: 'EXPLO',
  },
  {
    id: 'Price-Snapshot',
    name: 'Price Snapshot View',
    description: 'List of all materials/prices and date last updated',
    category: 'Commodities',
    reportId: 'zk1NzMa1gX',
    orgLevelReportId: 'MjAPXlJA2d',
    reportType: 'EXPLO',
  },
  {
    id: 'Operation-Inventory-Position',
    name: 'Inventory Position - Operational',
    description: 'Operation Inventory Position / Exposure Analysis',
    category: 'Inventory',
    reportId: 'QgYwVjWAvR',
    orgLevelReportId: '8L19J9qA56',
    reportType: 'EXPLO',
  },
  {
    id: 'Operation-Inventory-Financial',
    name: 'Inventory Position - Financial',
    description: 'Financial Inventory Position / Exposure Analysis',
    category: 'Inventory',
    reportId: 'zk1N96ExgX',
    orgLevelReportId: 'E3AaPO81Oq',
    reportType: 'EXPLO',
  },
  {
    id: 'Inventory-Reconciliation',
    name: 'Inventory Reconciliation',
    description: 'Time-Based Inventory Reconciliation Analysis',
    category: 'Inventory',
    reportId: '5L1B8jWYqe',
    orgLevelReportId: 'OVxbP0kADm',
    reportType: 'EXPLO',
  },
  {
    id: 'British-Columbia-Regulatory-Report',
    name: 'British Columbia Regulatory Report',
    description: 'British Columbia Compliance Report',
    category: 'Compliance',
    reportId: 'zk1N9VoxgX',
    orgLevelReportId: 'BKxgDO01LR',
    treatment: 'GREEN-6477_Embed_Metabase_Report_136',
    reportType: 'EXPLO',
  },
  {
    id: 'Alberta-Regulatory-Reporting',
    name: 'Alberta Regulatory Reporting',
    description: 'Alberta Compliance Report',
    category: 'Compliance',
    reportId: 'BKxgDrB1LR',
    orgLevelReportId: 'jv1O57eYzp',
    reportType: 'EXPLO',
  },
  {
    id: 'Cash-Drawer-Report',
    name: 'Cash Drawer Report',
    description: 'Cash Drawer Report',
    category: 'Settings',
    reportId: 'bo1qpMJxzw',
    orgLevelReportId: 'zk1N9K2xgX',
    reportType: 'EXPLO',
  },
  {
    id: 'Texas-DPS-Upload',
    name: 'Texas DPS Upload',
    description: 'Paid IBTs for Texas DPS Upload',
    category: 'Purchases',
  },
  {
    id: 'VIN-Report',
    name: 'VIN Report',
    description: 'List of all cars that were bought as scrap vehicles by a yard',
    category: 'Purchases',
    reportId: 'R81Ved6xZP',
    orgLevelReportId: 'P8xKPOb1oZ',
    reportType: 'EXPLO',
  },
  {
    id: 'Master-Customers-Report',
    name: 'Master Customers Report',
    description: 'Master Customers Report, including general information, locations and contacts',
    category: 'Customers',
    reportId: 'mNAdEdOYwB',
    orgLevelReportId: 'jDxeVRX1LG',
    reportType: 'EXPLO',
  },
  {
    id: 'Summary-Invoicing-Report',
    name: 'Summary Invoicing Report',
    description: 'Report of all invoices created in GreenSpark',
    category: 'Sales',
    reportId: 'p9170k5Aa3',
    orgLevelReportId: 'QgYwV6JAvR',
    reportType: 'EXPLO',
  },
  {
    id: 'Inbound-Ticket-Audit-Report',
    name: 'Inbound Ticket Audit Report',
    description: 'Internal Audit Report tracking for Inbound Tickets',
    category: 'Purchases',
    reportId: 'b81Jv4G1ag',
    orgLevelReportId: '8L19JywA56',
    reportType: 'EXPLO',
  },
  {
    id: 'Sales-Margin-Report',
    name: 'Sales / Margin Report',
    description: 'Sales - Margin Analysis by Material and Commodity',
    category: 'Sales',
    reportId: 'p9170w5Aa3',
    orgLevelReportId: 'mNAdPDjAwB',
    reportType: 'EXPLO',
  },
  {
    id: 'Positive-Pay-Report',
    name: 'Positive Pay Report',
    description: 'Check Purchase Export for Positive Pay',
    category: 'Purchases',
    reportId: 'R81V7XgAZP',
    orgLevelReportId: 'QRA3Byg1Ed',
    treatment: 'GREEN-7825_Metabase_Report_341_Positive_Pay',
    reportType: 'EXPLO',
  },
  {
    id: 'Tax-Report',
    name: 'Tax Report',
    description: 'A history of taxes paid on all inbound transactions',
    category: 'Purchases',
    reportId: 'OVxbldrADm',
    orgLevelReportId: 'bo1qJVKAzw',
    reportType: 'EXPLO',
  },
  {
    id: 'Purchases-By-Material',
    name: 'Purchases By Material',
    description: 'All Purchases, Grouped by Material',
    category: 'Purchases',
    reportId: 'b910jgBYWQ',
    orgLevelReportId: 'aBAMpdX1kv',
    reportType: 'EXPLO',
  },
  {
    id: 'Payment-Holds',
    name: 'Payment Holds',
    description: 'All Tickets and Materials with Payment Holds',
    category: 'Purchases',
    reportId: 'OVxbPLyADm',
    orgLevelReportId: 'L9YmnNjxXl',
    reportType: 'EXPLO',
  },
  {
    id: 'Dispatch-Ticket-Report',
    name: 'Dispatch Ticket Report',
    description: 'Summary Report of Dispatch Tickets',
    category: 'Dispatch',
    reportId: 'b910rqyYWQ',
    orgLevelReportId: '5L1B8MOYqe',
    treatment: 'app-route-load-board',
    reportType: 'EXPLO',
  },
  {
    id: 'Containers-Report',
    name: 'Containers Report',
    description: 'Summary Report of Container Status and Utilization',
    category: 'Dispatch',
    reportId: 'V4ArRJ2AmD',
    orgLevelReportId: 'V4ArRJ2AmD',
    treatment: 'app-route-load-board',
    reportType: 'EXPLO',
  },
  {
    id: 'Inbound-Freight-Cost-Report',
    name: 'Inbound Freight Cost Report',
    description: 'Inbound Freight Cost Analysis by Carrier / Customer',
    category: 'Freight',
    reportId: 'BKxgDkP1LR',
    orgLevelReportId: 'GnAkEKax3l',
    reportType: 'EXPLO',
  },
  {
    id: 'Outbound-Freight-Cost-Report',
    name: 'Outbound Freight Cost Report',
    description: 'Outbound Freight Cost Analysis by Carrier / Customer',
    category: 'Freight',
    reportId: '08YWnqnAW4',
    orgLevelReportId: 'aXxpbo2AqP',
    reportType: 'EXPLO',
  },
  {
    id: 'Lock-Accounting-Period-History-Report',
    name: 'Lock Accounting Period History Report',
    description: 'A history of lock accounting period settings',
    category: 'Compliance',
    reportId: 'BKxga37ALR',
    orgLevelReportId: null,
    reportType: 'EXPLO',
  },
  {
    id: 'Email-Status-Report',
    name: 'Email Status Report',
    description: 'A history of emails and attachments sent from GreenSpark',
    category: 'Compliance',
    reportId: 'OVxbKe61Dm',
    orgLevelReportId: 'E3Aal9g1Oq',
    reportType: 'EXPLO',
  },
  {
    id: 'Inventory-Transfers-Report',
    name: 'Inventory Transfers Report',
    description: 'Inventory transfer audit report of inbound and outbound tickets',
    category: 'Inventory',
    reportId: '5L1BXkJYqe',
    orgLevelReportId: 'XyAZoB3Ydl',
    reportType: 'EXPLO',
  },
  {
    id: 'ATM-Payments-Report',
    name: 'ATM Payments Report',
    description: 'ATM payments report for reconciliation and barcode activity tracking',
    category: 'Financial',
    reportId: 'OVxb64MxDm',
    orgLevelReportId: 'p9177OX1a3',
    reportType: 'EXPLO',
  },
  {
    id: 'Modified-Inventory-Reconciliation-Report',
    name: 'Modified Inventory Reconciliation Report',
    description: 'Modified Inventory Reconciliation Report',
    category: 'Financial',
    reportId: 'ovAR9431lV',
    orgLevelReportId: null,
    reportType: 'EXPLO',
  },
  {
    id: 'Portal-User-Report',
    name: 'Portal User Report',
    description: 'Customer Portal users and emails report',
    category: 'General',
    reportId: 'aQ1yVdKA8o',
    orgLevelReportId: 'aQ1yVdKA8o',
    reportType: 'EXPLO',
  },
  {
    id: 'Payables-Report-Bills',
    name: 'Payables Report',
    description: 'Payables Report',
    category: 'Purchases',
    reportId: 'V4ArzVgAmD',
    orgLevelReportId: '5L1BOPKAqe',
    reportType: 'EXPLO',
  },
  {
    id: 'Receivables-Report',
    name: 'Receivables Report',
    description: 'All overdue and forecasted receivables',
    category: 'Sales',
    reportId: '5rxlq631J9',
    orgLevelReportId: 'BKxgqvBALR',
    reportType: 'EXPLO',
  },
  // test report
  // {
  //   id: 'Dispatch-Ticket-Report-locale-test',
  //   name: 'Dispatch Ticket Report Locale Test',
  //   description: 'Summary Report of Dispatch Tickets',
  //   category: 'Dispatch',
  //   reportId: 'QRA3OEaAEd',
  //   orgLevelReportId: 'QRA3OEaAEd',
  //   treatment: 'app-route-load-board',
  //   reportType: 'EXPLO',
  // },
]

export const useBuildReportsList = () => {
  const settings = useSelector(state => state.settings.settings)
  const inOrgMode = useSelector(state => state.ui.inOrgMode)
  const {
    treatments,
    variables: {
      inventoryOverhaul,
      enableExploReports,
      enableModifiedInventoryRecReport,
      embedMonterreyAccountingReport,
      enableOutboundTicketAuditReport,
      enableGeographicMapDemoReport,
      enablePhoenixBankFileReport,
    },
  } = useSelector(state => state.featureFlags || {})

  const reports = enableExploReports || inOrgMode ? EXPLO_REPORTS : METABASE_REPORTS

  let filteredReports = reports.filter(report => {
    if (report.id === 'Texas-DPS-Upload') return !!settings?.purchaseSettings?.payment?.mreEntityId
    return report.treatment ? treatments[report.treatment]?.treatment === 'on' : true
  })

  if (inventoryOverhaul) {
    filteredReports = filteredReports.filter(report => report.reportId !== 76 && report.reportId !== 77)
  }
  if (embedMonterreyAccountingReport) {
    filteredReports = [
      ...filteredReports,
      {
        id: 'Quickbooks-Desktop-Uploads',
        name: 'Quickbooks Desktop Uploads',
        description: 'Quickbooks Desktop Uploads',
        category: 'Financial',
        reportId: 'aQ1yp4ex8o',
        orgLevelReportId: 'aQ1yp4ex8o',
        reportType: 'EXPLO',
      },
    ]
  }
  if (enableOutboundTicketAuditReport) {
    filteredReports = [
      ...filteredReports,
      {
        id: 'Outbound-Ticket-Audit-Report',
        name: 'Outbound Ticket Audit Report',
        description: 'Internal Audit Report tracking for Outbound Tickets',
        category: 'Sales',
        reportId: 'aXxprEQAqP',
        orgLevelReportId: '9PY4BP61M4',
        reportType: 'EXPLO',
      },
    ]
  }
  if (enableGeographicMapDemoReport) {
    filteredReports = [
      ...filteredReports,
      {
        id: 'Geographic-Distribution-of-Material-Sourcing-Report',
        name: 'Geographic Distribution of Material Sourcing Report',
        description: 'Geographic Distribution of Material Sourcing Report',
        category: 'Purchases',
        reportId: 'zk1NRqE1gX',
        orgLevelReportId: 'zk1NRqE1gX',
        reportType: 'EXPLO',
      },
    ]
  }
  if (enablePhoenixBankFileReport) {
    filteredReports = [
      ...filteredReports,
      {
        id: 'Phoenix-Bank-File-Report',
        name: 'Phoenix Bank File Report',
        description: 'Phoenix Bank File Report',
        category: 'Financial',
        reportId: 'OVxbmpkYDm',
        orgLevelReportId: 'OVxbmpkYDm',
        reportType: 'EXPLO',
      },
    ]
  }

  if (!enableModifiedInventoryRecReport) {
    filteredReports = filteredReports.filter(report => report.id !== 'Modified-Inventory-Reconciliation-Report')
  }
  if (!enableExploReports) {
    // remove metabase report
    filteredReports = filteredReports.filter(report => report.reportId !== 657)
    // add explo report here
    const exploReportToAdd = EXPLO_REPORTS.find(report => report.id === 'Cash-Drawer-Report')
    filteredReports = [...filteredReports, exploReportToAdd]
  }

  // requested to hide these reports in GREEN-7955
  // commented out for the moment until we get notice from Product
  // filteredReports = filteredReports.filter(report => report.reportId !== 83 && report.reportId !== 84)
  return filteredReports
}
